const EventStructure = {
    eventId: "",
    eventuuid: "",
    eventname: "",
    country: "",
    religion: "",
    eventtype: "",
    eventcoverimage: "",
    eventprofileimage: "",
    pincode: "",
    createdOn: "", 
    lastUpdate: "",
    eventcycle: "",
    advertises: [
      {
        advertiseId: "",
        advertiseUUID: "",
        profileId: "",
        advertiseImageUrl: "",
        PlannedDate: "",
        postedBy: "",
        postedOn: "",
      }
    ],
    users: [
      {
        userId: "",
        userUUID: "",
        userName: "",
        location: "",
        nationality: "",
        religion: "",
        joinedOn: "",
        lastupdate: "",
      }
    ],
    eventspec: [
      {
        foodName: "",
        foodtype: "",
        foodCategory: "",
        acceptancy: "",
      }
    ],
    feeds: [
      {
        postId: "", // Unique Post ID
        userId: "",
        useruuid: "",
        userimage: "",
        descriptions: "",
        timestamp: "", // ISO Date-Time String (e.g., "2025-03-03T12:00:00Z")
        locations: [
          {
            locationId: "",
            locationUUID: "",
            profileImage: "",
            vulanteers: [
              {
                userid: "",
                useruuid: "",
                username: "",
                userimage: "",
              }
            ]
          }
        ],
        nlikes: 0, // Number of likes
        medias: [
            {
              mediaId: "",
              mediauuid: "",
              descriptions: "",
              uploadedBy: "",
              mediasize: "",
              mediatype: "",
              imageurl: "",
              nlikes: 0, // Number of likes
              comments: [
                {
                  userId: "", // User who commented
                  comment: "", // Comment text
                  timestamp: "", // Comment time
                  location: "", // Comment location (optional)
                },
              ],
              nshares: 0, // Number of times shared
              nsuggests: 0,
            }
          ],
          comments: [
            {
              userId: "", // User who commented
              comment: "", // Comment text
              timestamp: "", // Comment time
              location: "", // Comment location (optional)
            },
          ],
          nshares: 0, // Number of times shared
        },
      ],
    };
  
  export default EventStructure;
  